import { ContainerOutlined, LogoutOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import { signOut } from 'firebase/auth';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { auth } from '../../../services/firebase/auth';
import { useAppDispatch, useTypedSelector } from '../../../store';
import { subscriberStatusReset } from '../../../store/user';
import { lsSaveReset } from '../../../store/lawsuitUI';
import { BLACK, BLUE_DARK, RowSm } from '../../../styles';
import { ButtonFullWidth, EmptyButton, LinkFullWidth } from '../../../styles/ui';
import { withAppLoading } from '../../../utils/helpers/withAppLoading';
import { HomeDescWrapper, HomeMenuWrapper, HomeTitleWrapper } from '../HomeUI/HomeUI';

const MenuAuthOpts = (
  {
    setSignUpVisible,
    setLoginVisible
  }: {
    setSignUpVisible: (signUpVisible: boolean) => void,
    setLoginVisible: (isLoginVisible: boolean) => void
  }
) => {
  const userExists = useTypedSelector(state =>
    state.user.isNonAnonymousUserLoggedIn);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const onLogout = async () => {
    withAppLoading({ dispatch }, async () => {
      try {
        await signOut(auth);
        dispatch(lsSaveReset());
        dispatch(subscriberStatusReset());
      } catch {
        notification.open({
          type: 'error',
          message: 'Ups!',
          description: t('error.general')
        });
      }
    });
  };
  return (
    <div>
      <HomeTitleWrapper
        borderColor={BLUE_DARK}
        title={userExists ? t('home.menu.account') : t('home.menu.title3')}
        level={5}
      />
      <HomeDescWrapper>{userExists  ? t('home.menu.save2') : t('home.menu.save')}</HomeDescWrapper>
      {!userExists  ? (
        <>
          <HomeMenuWrapper>
            <EmptyButton
              style={{ width: '100%' }}
              color={BLACK}
              hoverColor="white"
              hoverBg={BLACK}
              icon={<ContainerOutlined />}
              disabled
              onClick={() =>
                setSignUpVisible(true)}
            >
              {t('home.menu.title3')}
            </EmptyButton>
          </HomeMenuWrapper>
          <RowSm>
            <ButtonFullWidth
              disabled
              type="link"
              onClick={() =>
                setLoginVisible(true)}
            >
              {t('home.menu.already')}
            </ButtonFullWidth>
          </RowSm>
        </>
      ) :       (
        <HomeMenuWrapper>
          <LinkFullWidth
            to={{ pathname: '/dashboard' }}
          >
            <EmptyButton
              style={{ width: '100%' }}
              color={BLACK}
              hoverColor="white"
              hoverBg={BLACK}
              icon={<ContainerOutlined />}
              disabled
            >
              {t('dashboard.title')}
            </EmptyButton>
          </LinkFullWidth>
          <RowSm>
            <ButtonFullWidth
              type="link"
              onClick={onLogout}
              icon={<LogoutOutlined />}
              disabled
            >
              {t('home.menu.logout')}
            </ButtonFullWidth>
          </RowSm>
        </HomeMenuWrapper>
      )}
    </div>
  );
};

export default MenuAuthOpts;
